import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Bank {
  name: string;
  logo: string;
}

@Component({
  selector: 'app-installment-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './installment-badge.component.html',
  styleUrls: ['./installment-badge.component.css']
})
export class InstallmentBadgeComponent {
  @Input() price: number = 0;
  @Input() maxInstallment: number = 9; // Kıbrıs: 3, Yurtiçi: 9, Yurtdışı: 0
  @ViewChild('badgeBtn', { static: true }) badgeBtn!: ElementRef<HTMLElement>;

  showMaxPopup = false;
  showBankTable = false;
  maxPopupStyle: { [key: string]: string } = {};

  get maxInstallments() {
    return [
      { count: 3, label: '3 Taksit' },
      { count: 6, label: '6 Taksit' },
      { count: 9, label: '9 Taksit' },
    ].filter(opt => opt.count <= this.maxInstallment);
  }

  get badgeText(): string {
    if (this.maxInstallment <= 0) return 'Tek Çekim';
    return `Peşin Fiyatına ${this.maxInstallment} Taksit`;
  }

  readonly banks: Bank[] = [
    { name: 'Bonus', logo: 'assets/banklogos/bonus logo.png' },
    { name: 'World', logo: 'assets/banklogos/world.png' },
    { name: 'Vakıfbank World', logo: 'assets/banklogos/world vakçf.png' },
    { name: 'QNB Finansbank', logo: 'assets/banklogos/qnb.png' },
    { name: 'Ziraat Bankası', logo: 'assets/banklogos/ziraat.png' },
    { name: 'Paraf', logo: 'assets/banklogos/faraf.png' },
  ];

  openMaxPopup(): void {
    if (this.maxInstallment <= 0) return; // Taksit yoksa popup açma
    this.calculatePosition();
    this.showMaxPopup = true;
  }

  closeMaxPopup(): void {
    this.showMaxPopup = false;
  }

  toggleBankTable(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.showBankTable = !this.showBankTable;
  }

  closeBankTable(): void {
    this.showBankTable = false;
  }

  private calculatePosition(): void {
    const el = this.badgeBtn.nativeElement;
    const rect = el.getBoundingClientRect();
    const popupWidth = 300;
    const popupHeight = 320;
    const margin = 8;

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    let top: number;
    if (spaceBelow >= popupHeight + margin) {
      top = rect.bottom + margin;
    } else if (spaceAbove >= popupHeight + margin) {
      top = rect.top - popupHeight - margin;
    } else {
      top = Math.max(margin, window.innerHeight - popupHeight - margin);
    }

    let left = rect.left;
    if (left + popupWidth > window.innerWidth - margin) {
      left = window.innerWidth - popupWidth - margin;
    }
    if (left < margin) left = margin;

    this.maxPopupStyle = {
      position: 'fixed',
      top: top + 'px',
      left: left + 'px',
      width: popupWidth + 'px',
    };
  }
}
